import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const GoogleAnalytics = () => {
	const location = useLocation();
	const hostname = window.location.hostname;
	const gaId = useMemo(() => {
		if (hostname.includes("research.openrecovery.com")) {
			return "G-FKTZJJZTME";
		}
		return "G-SEQ0VVB0FD";
	}, [hostname]);

	useEffect(() => {
		// Initialize GA with the correct ID from environment
		if (typeof window.gtag === "function") {
			console.log("Initializing GA with ID:", gaId);
			window.gtag("config", gaId);
		} else {
			console.warn("Google Analytics not loaded (gtag not found)");
		}
	}, [gaId]); // Run once on mount

	useEffect(() => {
		// Track page views
		if (typeof window.gtag === "function") {
			// Create a URL object to manipulate the search params
			const url = new URL(window.location.href);

			// Remove the token parameter if it exists
			if (url.searchParams.has("token")) {
				url.searchParams.delete("token");
			}

			// Get the clean path without the token
			const cleanPath = location.pathname + (url.search ? url.search : "");

			console.log("Tracking page view:", cleanPath);
			window.gtag("config", gaId, {
				page_path: cleanPath,
				send_page_view: false, // We're sending the pageview manually
			});
		}
	}, [location, gaId]);

	return null;
};

export default GoogleAnalytics;
